// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"c7955ed6","284":"5d07caee","321":"41989eca","467":"b6fd5452","501":"7c90998a","612":"3df9cd4a"}[chunkId] + ".chunk.css";
};